import React, { useEffect, useState } from "react";
import SubscriptionTile from "../components/SubscriptionTile";
import axios from "axios";
import { API_BASE_URL } from '../config';
import "./subscription.css"
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const SubscriptionPage = () =>
{
  const [username, setUsername] = useState('');
  const navigate = useNavigate();
  const [subscriptions, setSubscriptions] = useState([]);

  const handleLoginClick = () =>
  {
    navigate('/home-user-login');
  };

  const handleSignupClick = () =>
  {
    navigate('/register-home-user');
  };


  useEffect(() =>
  {
    const token = localStorage.getItem('token');
    if (token !== null)
    {
      const decodeToken = jwtDecode(token);
      setUsername(decodeToken.UserName);
    }
  }, [username]);

  useEffect(() =>
  {
    const token = localStorage.getItem('token');
    if (token)
    {
      const decodeToken = jwtDecode(token);
      const businessId = decodeToken.BusinessId;
      const fetchSubscriptions = async () =>
      {
        try
        {
          const response = await axios.get(`${API_BASE_URL}/api/Subscription/getSubscriptionTypes`,
            {
              params: {
                mtype: 'LISTING',
                bizid: businessId,
              }
            }
          );
          setSubscriptions(response.data);
          console.log('Fetched SubscriptionTypes:', response.data);
        } catch (error)
        {
          console.error("Error fetching subscriptions: ", error);
        }
      };
      fetchSubscriptions();
    }
  }, []);

  const handlePurchase = async (title, stripeProductId, mySubscriptionTypeId) =>
  {
    try
    {
      const token = localStorage.getItem('token');
      if (token)
      {
        const decodeToken = jwtDecode(token);
        const businessId = decodeToken.BusinessId;
        const response = await axios.post(`${API_BASE_URL}/api/StripeWebhook/create-checkout-session`, {
          priceId: stripeProductId,
          businessId: businessId,
          successUrl: `${window.location.origin}/subscription/success`,
          cancelUrl: `${window.location.origin}/subscription/cancel`,
          customerEmail: decodeToken.unique_name,
          subscriptionTypeId: mySubscriptionTypeId,
          title: title,
        });

        const { id, url } = response.data;
        window.location.href = url;
      }
    } catch (error)
    {
      console.error('Error creating checkout session: ', error);
    }
  };


  return (
    <div>
      <h1 class="inner-page-heading">Purchase Subscription</h1>
      <p class="inner-heading-desc-businessdash">Below are the subscriptions available for purchase</p>
      <div className="subscription-tiles">
        {subscriptions.map((subscription, index) => (
          <SubscriptionTile
            key={index}
            price={subscription.price}
            title={subscription.title}
            features={Array.isArray(subscription.features) ? subscription.features.map(feature => feature.featureName) : []}
            stripe_product={subscription.stripeProductId}
            hasValidSubscription={subscription.hasValidSubscription}
            checkmarkSrc={subscription.checkmarkSrc}
            onPurchase={() => handlePurchase(subscription.title, subscription.stripeProductId, subscription.subscriptionTypeId)}
          />
        ))}
      </div>
    </div>

  );
};

export default SubscriptionPage;